export const getImagesToDisplay = (images = [], beginImageDisplayAt) => {
	const start = Math.max(1, parseInt(beginImageDisplayAt, 10) || 1) - 1;

	return [0, 1, 2].map((offset) => images[start + offset] || null);
};
